import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { ApplyFormFieldValues } from 'pages/Apply/context';

export interface ApplyFormPersonalInformationFieldsHook {
  hasMiddleName: boolean;
  hasMaidenName: boolean;
}

export default function useApplyFormPersonalInformationFields(): ApplyFormPersonalInformationFieldsHook {
  const [middleName, maidenName] = useWatch<ApplyFormFieldValues>({
    name: [
      'credit.customer_details.middle_name',
      'credit.customer_details.maiden_name',
    ],
  });

  const hasMiddleName = useMemo(() => middleName !== undefined, [middleName]);
  const hasMaidenName = useMemo(() => maidenName !== undefined, [maidenName]);

  return {
    hasMiddleName,
    hasMaidenName,
  };
}
